import autoBind from 'react-autobind';
import { getTypeDescription } from './LanguageSyntaxHelper';

var antlr4 = require('antlr4');

class LanguageErrorListener extends antlr4.error.ErrorListener {
  constructor() {
    super();
    autoBind(this);
    this.errors = [];
  }

  /**
   * Chamado ao erros serem identificados na análise da entrada de texto.
   * @param {*} recognizer
   * @param {*} offendingSymbol Dados sobre o texto que causou o erro
   * @param {int} line Linha do erro
   * @param {int} column Coluna do erro na linha
   * @param {string} msg Mensagem do erro produzida pelo Antlr
   * @param {*} err Exceção produzida
   */
  syntaxError(recognizer, offendingSymbol, line, column, msg, err) {
    let mensagem = `Erro indefinido em '${offendingSymbol.text}'`;
    let tipoErro = 'indefinido';
    let texto = '';

    const regexMissing = /missing\s('(?<char>(.*?))'|[a-zA-Z0-9._@\[\]]+)/;
    const regexExtraneous = /extraneous input\s('(?<char>(.*?))'|[a-zA-Z0-9._@\[\]]+)/;
    const regexExpecting = /expecting\s(?<type>[A-Z_]+)/;

    if (offendingSymbol.text === '<EOF>') {
      tipoErro = 'missing';
      texto = 'retorno;';
      mensagem = 'A fórmula deve finalizar com um retorno';
    } else if (msg.match(regexMissing)) {
      tipoErro = 'missing';
      texto = msg.match(regexMissing).groups.char || 'identificador';
      mensagem = msg.match(regexMissing).groups.char
        ? `Faltando '${msg.match(regexMissing).groups.char}'`
        : 'Entidade ou valor não definido';
    } else if (msg.match(regexExtraneous)) {
      mensagem = msg.match(regexExtraneous).groups.char
        ? `Caractér '${msg.match(regexExtraneous).groups.char}' não esperado`
        : 'Entidade ou valor não definido';
    } else if (err) {
      switch (err.constructor.name) {
        case 'NoViableAltException':
          mensagem = `Expressão inválida '${offendingSymbol.text}'`;
          break;
        case 'MismatchedCharException':
          mensagem = `Cáracter inesperado '${offendingSymbol.text}' encontrado`;
          break;
        case 'NoViableAltForCharException':
          mensagem = `Semántica inválida '${offendingSymbol.text}' encontrada`;
          break;
        case 'MismatchedTokenException':
          mensagem = `Comando '${offendingSymbol.text}' não esperado`;
          break;
        case 'InputMismatchException':
          const type = msg.match(regexExpecting) ? msg.match(regexExpecting).groups.type : undefined;
          const description = getTypeDescription(type);
          mensagem = description
            ? `Esperado ${description}, encontrado '${offendingSymbol.text}'`
            : `Entrada${offendingSymbol.text !== '<EOF>' ? ` '${offendingSymbol.text}'` : ''} não esperada`;
          break;
        default:
          mensagem = 'Erro indefinido';
          break;
      }
    } else {
      mensagem = 'Erro indefinido';
    }

    this.errors.push({
      linha: line,
      coluna: column,
      mensagem: mensagem,
      colunaFim: offendingSymbol.stop - offendingSymbol.start + column,
      texto: texto || offendingSymbol.text,
      tipo: tipoErro,
    });
  }
}

export default LanguageErrorListener;
